import * as React from "react"

const SvgLongArrowRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16.154 13.14H5a.97.97 0 0 1-.712-.288A.97.97 0 0 1 4 12.14q0-.424.288-.712A.97.97 0 0 1 5 11.14h11.154l-2.851-2.848a.92.92 0 0 1-.288-.7q.014-.4.288-.7.3-.3.713-.312a.93.93 0 0 1 .712.288l4.577 4.572q.15.15.212.325.063.175.063.375c0 .2-.02.258-.063.375a.9.9 0 0 1-.212.324l-4.577 4.573q-.3.3-.712.287a1.02 1.02 0 0 1-1-1.012.92.92 0 0 1 .287-.7l2.85-2.848Z" />
  </svg>
)
export default SvgLongArrowRight
